<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M17.751 5.00946C18.1157 4.65318 18.6832 4.63203 19.0719 4.94158L19.1652 5.02586L19.2622 5.12532C21.0086 6.9696 22 9.40828 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 9.52097 2.90708 7.18195 4.52383 5.35934L4.74867 5.11404L4.83483 5.02586C5.2208 4.63083 5.85392 4.62349 6.24895 5.00946C6.61359 5.36573 6.6479 5.9326 6.34745 6.32841L6.26536 6.42357L6.19004 6.50048C4.79197 7.9769 4 9.925 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 10.0342 19.2892 8.18231 18.0349 6.74706L17.8208 6.51176L17.7346 6.42357C17.3487 6.02855 17.356 5.39542 17.751 5.00946ZM12 2C12.5523 2 13 2.44772 13 3V11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V3C11 2.44772 11.4477 2 12 2Z"
    fill="currentColor"
  />
</svg>
